module.exports = __webpack_public_path__ + "static/media/fnnlogo.e831be80.png";